import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Start from 23:59:51
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 51
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-3xl md:text-5xl font-serif font-bold text-brand-cream-light" data-id="element-48">
      <div className="flex flex-col items-center" data-id="element-49">
        <span className="bg-brand-darker px-4 py-2 rounded-lg border border-brand-primary/30 shadow-inner" data-id="element-50">
          {format(timeLeft.hours)}
        </span>
        <span className="text-xs font-sans text-brand-primary mt-2 uppercase tracking-widest" data-id="element-51">
          hs
        </span>
      </div>
      <span className="text-brand-primary pb-6" data-id="element-52">:</span>
      <div className="flex flex-col items-center" data-id="element-53">
        <span className="bg-brand-darker px-4 py-2 rounded-lg border border-brand-primary/30 shadow-inner" data-id="element-54">
          {format(timeLeft.minutes)}
        </span>
        <span className="text-xs font-sans text-brand-primary mt-2 uppercase tracking-widest" data-id="element-55">
          min
        </span>
      </div>
      <span className="text-brand-primary pb-6" data-id="element-56">:</span>
      <div className="flex flex-col items-center" data-id="element-57">
        <span className="bg-brand-darker px-4 py-2 rounded-lg border border-brand-primary/30 shadow-inner" data-id="element-58">
          {format(timeLeft.seconds)}
        </span>
        <span className="text-xs font-sans text-brand-primary mt-2 uppercase tracking-widest" data-id="element-59">
          seg
        </span>
      </div>
    </div>;
}